/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CommonService } from '../services/common.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-requirements-modal',
  templateUrl: './requirements-modal.component.html',
  styleUrls: ['./requirements-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
// It seems that some part of the code are duplicated, we work in CriteriaRulesModalComponent and the logic is simplified
export class RequirementsModalComponent implements OnInit {
  @ViewChild('requirementsForm') requirementsForm!: NgForm;
  @Output() closeModal = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();
  @Input() modalData: any;
  public isFromChangeSponsor!: boolean;
  public title: string = '';
  public requirementRules: Array<any> = [];
  public noRequirementRules = false;
  public operationIndex = 0;

  constructor(public bsModalRef: BsModalRef, private commonService: CommonService) {}

  ngOnInit() {
    if(this.modalData) {
      this.modalData.fieldNameToShow = this.modalData.fieldNameToShow || 'code';
      this.modalData.fieldNameToMap = this.modalData.fieldNameToMap || 'id';
      this.modalData.dialogClass = 'modal-dialog requirements-modal';
      this.title = this.modalData.title;
      this.requirementRules = this.modalData.requirementRules || [];
    }
    this.requirementRules.forEach(reqRule => {
      reqRule['operation'] = 'Update';
      reqRule['volumeType'] = reqRule.type;
      reqRule['operationIndex'] = this.operationIndex;
      this.operationIndex++;
    });
  }

  public getTranslationWithKey(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }

  public closeModalWindow() {
    this.onClose.emit('closed');
    this.bsModalRef.hide();
  }

  public applyChange() {
    this.requirementRules.forEach(reqRule => {
      reqRule['volumeType'] = this.getType(reqRule.code);
    });
    this.onClose.emit({ data: this.requirementRules });
    this.bsModalRef.hide();
  }

  private getType(code: string) {
    let returnCode = '';
    this.modalData.allRequirementDefinitionsMetadata.forEach((item: any) => {
      if (item.code === code) {
        returnCode = item.type;
      }
    });
    return returnCode;
  }

  public addNewRequirement() {
    this.noRequirementRules = false;
    const reqRule: any = {};
    reqRule['operation'] = 'Create';
    reqRule['code'] = '';
    reqRule['value'] = '';
    reqRule['operationIndex'] = this.operationIndex++;
    this.requirementRules.push(reqRule);
  }

  public removeRequirement(reqRule: any, index: number) {

    if (reqRule.id) {
      reqRule['operation'] = 'Delete';
      this.requirementsForm?.form?.markAsDirty();
    } else {
      this.requirementRules.splice(index, 1);
    }

    // logic to show No Volume Rules
    const deletedRules = this.requirementRules.filter(function (rule) {
      return (rule.operation === 'Delete');
    });
    this.noRequirementRules = (deletedRules.length === this.requirementRules.length);
  }

  onKeyPress(evt: any) {
    // This function will allow user to enter only numeric values (0-9)in the input field
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode !== 46 && charCode >= 48 && charCode <= 57) {
      return true;
    }
    return false;
  }

  public onKeyDown(evt: any){
    const restrcitKeys=[189, 109, 107];
    if(restrcitKeys.indexOf(evt.keyCode)>-1){
      return false;
    }else{
      return true;
    }
  }
}
